export function employerVerificationFinalChipColor(
  status: string | null,
): 'success' | 'error' | 'warning' | 'default' {
  const s = (status ?? '').trim().toUpperCase();
  if (s === 'VERIFIED') return 'success';
  if (s === 'REJECTED') return 'error';
  if (s === 'MANUAL_REVIEW') return 'warning';
  return 'default';
}
